// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IPublicMyHomeNewbuildingV2CreateRealtyRequest,
  TPublicMyHomeNewbuildingV2CreateRealtyModel,
  IMappers,
  TPublicMyHomeNewbuildingV2CreateRealtyResponse,
  IPublicMyHomeNewbuildingV2CreateRealtyResponse,
  IPublicMyHomeNewbuildingV2CreateRealtyResponseError,
} from './types';

export const defaultConfig: TPublicMyHomeNewbuildingV2CreateRealtyModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/my-home/newbuilding/v2/create-realty/',
  requestType: 'json',
} as TPublicMyHomeNewbuildingV2CreateRealtyModel;

export function createPublicMyHomeNewbuildingV2CreateRealtyModel(
  parameters: IPublicMyHomeNewbuildingV2CreateRealtyRequest,
): TPublicMyHomeNewbuildingV2CreateRealtyModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublicMyHomeNewbuildingV2CreateRealtyOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPublicMyHomeNewbuildingV2CreateRealtyRequest;
}

export async function fetchPublicMyHomeNewbuildingV2CreateRealty<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicMyHomeNewbuildingV2CreateRealtyOptions<TResponse200, TResponse400>): Promise<
  TPublicMyHomeNewbuildingV2CreateRealtyResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createPublicMyHomeNewbuildingV2CreateRealtyModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicMyHomeNewbuildingV2CreateRealtyResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IPublicMyHomeNewbuildingV2CreateRealtyResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicMyHomeNewbuildingV2CreateRealtyResponse;
}
